"use client";
//#region packages/@mantine/core/src/core/MantineProvider/convert-css-variables/css-variables-object-to-string.ts
function cssVariablesObjectToString(variables) {
	return Object.entries(variables).map(([name, value]) => `${name}: ${value};`).join("");
}
//#endregion
export { cssVariablesObjectToString };

//# sourceMappingURL=css-variables-object-to-string.mjs.map